import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { serializer } from './serializer';

bus.on(constants.EVENTS.LEADERBOARD.LIST_ALL.REFRESH, () => {
  const requestId = `listAllLeaderboard-${Date.now()}`;
  bus.emit(constants.EVENTS.LEADERBOARD.LIST_ALL.REFRESHING);

  // Récupérer l'userId du user store
  const userStore = getStore('user');
  const currentUserId = userStore?.state?.current?.id || null;
  console.log("🚀 ~ currentUserId:", currentUserId)

  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: `${constants.ENDPOINTS.LEADERBOARD.GET_LIST}`,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      // Passer l'userId au serializer
      const parsed = serializer.deserialize(res, currentUserId);
      if (parsed.success) {
        bus.emit(constants.EVENTS.LEADERBOARD.LIST_ALL.REFRESHED, parsed.data);
      } else {
        bus.emit(constants.EVENTS.LEADERBOARD.LIST_ALL.REFRESH_ERROR, parsed);
      }
    }
  });
});
